const MapLocation = () => {
  return (
    <section className="wpo-contact-map-section">
      <div className="wpo-contact-map">
        <iframe
          title="Dar Attaoui location map"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4040.426002222138!2d-6.881055824286272!3d33.98861307318101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDU5JzE5LjAiTiA2wrA1Mic0Mi41Ilc!5e1!3m2!1sen!2sma!4v1766772292528!5m2!1sen!2sma"
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};
export default MapLocation;
